import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styles from "../../assets/css/modules/cover/excess.css";
import InfoBox from "../../components/shared/InfoBox";
import { nonClaimsModules } from "../../constants/SMEModulesToMatchOn";
import Content from "../../content/Content";
import Store from "../../content/Store";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import Doughnut from "../shared/Doughnut";
import MakeAClaimButton from "./../../components/shared/buttons/MakeAClaimButton";

function createChartOptions(usedExcessAmount, remainingExcessAmount) {
  return [
    {
      key: Store.Cover.ExcessUsedAmount + usedExcessAmount,
      value: usedExcessAmount,
      color: "#fad6de"
    },
    {
      key: Store.Cover.ExcessRemainingAmount + remainingExcessAmount,
      value: remainingExcessAmount,
      color: "#fcd385"
    }
  ];
}

export class CoverExcessSummary extends Component {
  render() {
    var chartDataOptions = createChartOptions(
      Number(this.props.excess.UsedExcessAmount).toFixed(2),
      Number(this.props.excess.RemainingExcessAmount).toFixed(2)
    );
    return (
      <div className={styles.excess}>
        <h2>
          <Content name={Store.Cover.ExcessTitle} />
        </h2>

        <div className="row">
          <div className="col-lg-7">
            <p>
              {this.props.excess && this.props.excess.ShouldShowExcess ? (
                <Content name={Store.Cover.ExcessDescription} />
              ) : (
                <Content name={Store.Cover.ExcessNotExist} />
              )}
            </p>
          </div>
          {this.props.shouldShowClaims && (
            <div className="offset-lg-1 col-lg-4 hidden-md-down">
              <p>{Store.Cover.NewClaimTitle}</p>
              <MakeAClaimButton />
            </div>
          )}
        </div>
        {this.props.excess && this.props.excess.ShouldShowExcess ? (
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <div className={styles.totalExcess}>
                  <Content name={Store.Cover.TotalExcess} />
                  <span id="totalExcessAmount">
                    {Number(this.props.excess.TotalExcessAmount).toFixed(2)}
                  </span>
                </div>

                <Doughnut
                  data={chartDataOptions}
                  legendColorConfig={[
                    { color: "#fad6de" },
                    { color: "#fcd385" }
                  ]}
                />
              </div>
            </div>
            {this.props.isDoubleExcess ? (
              <div className="row">
                <div className="col-12">
                  <InfoBox
                    iconClass={"icon-functional-help"}
                    className={styles.infoBoxOverride}
                  >
                    <Content name={Store.Cover.DoubleExcessWarning} />
                  </InfoBox>
                </div>
              </div>
            ) : null}
          </React.Fragment>
        ) : null}

        {this.props.shouldShowClaims && (
          <div className="row hidden-lg-up">
            <div className="col-12">
              <p>{Store.Cover.NewClaimTitle}</p>
              <MakeAClaimButton />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export const mapStateToCoverExcessSummary = (state) => {
  return {
    shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
      state.policyReducer && state.policyReducer.selectedPolicy,
      nonClaimsModules
    )
  };
};

export default withRouter(
  connect(mapStateToCoverExcessSummary)(CoverExcessSummary)
);
